import { YoutubeLogo } from '@phosphor-icons/react';

export default YoutubeLogo;
